import App from '../../../vendor_core/core/src/App';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import { Tween } from '../../../vendor_core/core/src/Tween';
import UIController from '../../../vendor_core/core/src/ui/UIController';
import { UIStates } from '../../../vendor_core/core/src/ui/UIStates';
import KeyboardManager, { Key } from '../../../vendor_core/core/src/utils/KeyboardManager';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import ReelGroup from '../../../vendor_core/core/src/views/ReelGroup';
import Configs from '../../../vendor_core/src/vendorConfigs/Configs';
import CoinModel from '../../model/CoinModel';
import VendorSpinResultState from '../../../vendor_core/src/states/VendorSpinResultState';

export default class TRWSpinResultState extends VendorSpinResultState {


    public enter(){
        super.enter();
    }
    // Value must be in ms
    private _exitStateDelayOnTurboFreeSpinsMode = 200; // 1000

    public get exitStateDelayOnTurboFreeSpinsMode(): number {
        return this._exitStateDelayOnTurboFreeSpinsMode / 1000
    }

    public exit(): void {
        if (SpinModel.isInFreespins() && GameModel.turboSpin) {
            Tween.delayedCall(this.exitStateDelayOnTurboFreeSpinsMode, () => super.exit())
        } else {
            super.exit()
        }
    }

    protected init(): void {
        // CommManager.send(RequestRegister.get("saveRestoreState"), () => { }, this);

        super.init();
    }

    /**
     * Here, exit needs to be called only for cascade games
     */
    protected setSkipWithSpace(): void {
        if (GameModel.spaceToSpin) {
            KeyboardManager.onKey("pressed", Key.SPACE, this.skipWithKey, this);
        }
    }

    // Set Stop Spin Btn only when min spin time is passed
    protected setUIStateOnReelStop(): void {
        const reelGroup = <ReelGroup>ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup");
        if (reelGroup.getSpinTimePassed() >= (App.config.minSpinTime * 1000)) {
            UIController.setState(UIStates.SPIN_RESULT);
        } else {
            if (Configs.reels?.clientMinSpinTime && (App.config.minSpinTime * 1000) < Configs.reels.clientMinSpinTime && !GameModel.turboSpin) {
                const delay = (App.config.minSpinTime * 1000) - reelGroup.getSpinTimePassed()
                Tween.delayedCall((delay / 1000), () => {
                    UIController.setState(UIStates.SPIN_RESULT);
                })
            }
        }
    }

    protected stopReels(): void {
        CoinModel.clearTextOverlays();

        if (App.config.minSpinTime < (Configs.reels?.clientMinSpinTime || 0)) {
            const reelGroup = <ReelGroup>ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup");

            if (reelGroup.getSpinTimePassed() >= ((Configs?.reels?.clientMinSpinTime || (App.config.minSpinTime * 1000)) - this.getStopTime()) || GameModel.turboSpin) {
                if (GameModel.turboSpin) {
                    let delay = (App.config.minSpinTime * 1000) - reelGroup.getSpinTimePassed() - reelGroup.getSpinStopTime();
                    if (delay < 0) {
                        // Delay for security for passing min spin time  (because is possible calculation for spin pass time have correction of +- 20-40 ms )
                        delay = 100;
                    }
                    super.stopReels((delay / 1000))
                } else {
                    super.stopReels()
                }
            } else {
                super.stopReels(this.getStopReelsDelayTime(reelGroup))
            }
        } else {
            super.stopReels()
        }
    }

    // This is client specific logic !!!
    private getStopReelsDelayTime(reelGroup: ReelGroup): number {
        let result = 0;
        if (Configs?.game?.gameType === "normal") {
            result = Math.max((Configs.reels?.clientMinSpinTime || 0), (App.config.minSpinTime * 1000)) - reelGroup.getSpinTimePassed() - reelGroup.getSpinStopTime();
            // Need to converted in seconds
            result /= 1000;
        } else {
            // Don't need to converted in seconds
            result = Math.max((Configs.reels?.clientMinSpinTime || 0), (App.config.minSpinTime * 1000)) - reelGroup.getSpinTimePassed() - reelGroup.getSpinStopTime();
        }

        if (result < 0) {
            result = 0;
        }

        return Math.floor(result);
    }

    private getStopTime(): number {
        // Normal game stop time in ms !
        let result = App.config.stopTime * 1000;
        if (Configs?.game?.gameType === "cascade") {
            if (Configs?.reels) {
                if (GameModel.turboSpin) {
                    result = (Configs.reels.cascadeProps.mainSpinProps.stopSymbolAnimTimeInTurboMode
                        + (Configs.reels.cascadeProps.mainSpinProps.stopReelDelayInTurboMode * Configs.reels.numberOfReels)
                        + Configs.reels.cascadeProps.mainSpinProps.stopSymbolDelayInTurboMode) / 1000;
                } else {
                    result = (Configs.reels.cascadeProps.mainSpinProps.stopSymbolAnimTime
                        + (Configs.reels.cascadeProps.mainSpinProps.stopReelDelay * Configs.reels.numberOfReels)
                        + Configs.reels.cascadeProps.mainSpinProps.stopSymbolDelay) / 1000;
                }
            }
        }

        return result;
    }
}
